<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text"><a href="#/xhtml/frantmatter03">The Cazalet Family Tree</a></p>
<p class="toc-text1"><a href="#/xhtml/frantmatter04">The Cazalet Family and their Servants</a></p>
<p class="toc-text"><a href="#/xhtml/part01">PART ONE</a></p>
<p class="toc-text1"><a href="#/xhtml/chapter001">Landsdowne Road: 1937</a></p>
<p class="toc-text1"><span href="#/xhtml/chapter002" title="Link target outside of Sample">Home Place: 1937</span></p>
<p class="toc-text"><span href="#/xhtml/part02" title="Link target outside of Sample">PART TWO</span></p>
<p class="toc-text1"><span href="#/xhtml/chapter003" title="Link target outside of Sample">Home Place: Late Summer 1938</span></p>
<p class="toc-text1"><span href="#/xhtml/chapter004" title="Link target outside of Sample">Home Place: September 1939</span></p>
<p class="toc-text"><span href="#/xhtml/preview" title="Link target outside of Sample">Preview: <i>Marking Time</i></span></p>
<p class="toc-text1"><span><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?a05a577a